export function getGclidFromCookie() {
    const cookie = document.cookie
        .split("; ")
        .find(row => row.startsWith("_gcl_aw="))
        ?.split("=")[1]

    if (!cookie) return ""

    // Format is GCL.timestamp.gclid — extract just the gclid part
    const parts = cookie.split(".")
    return parts.length >= 3 ? parts.slice(2).join(".") : ""
}

export function getGclid() {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get("gclid") || getGclidFromCookie()
}

export default function googleTagManager() {
    ;(function (window, document, script, dataLayer, id) {
        window[dataLayer] = window[dataLayer] || []
        window[dataLayer].push({
            "gtm.start": new Date().getTime(),
            event: "gtm.js"
        })
        var f = document.getElementsByTagName(script)[0]
        var j = document.createElement(script)
        var dl = dataLayer != "dataLayer" ? "&l=" + dataLayer : ""
        j.async = true
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + id + dl
        f.parentNode.insertBefore(j, f)
    })(window, document, "script", "dataLayer", "GTM-KZ5BW4R2")
}